// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RedoSearch-redoContainer-K35GI {
  position: absolute;
  bottom: 9px;
  left: 0;
  z-index: 1;
  right: 0;
  max-width: -webkit-max-content;
  max-width: -moz-max-content;
  max-width: max-content;
  margin: 0 auto;
}

.RedoSearch-redoContent-zGvws {
  padding: 9px 15px;
  background-color: var(--primary-white-bg);
  border-radius: 6px;
  -webkit-box-shadow: 0px 8px 11px #3131310f;
          box-shadow: 0px 8px 11px #3131310f;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  border: 1px solid var(--primary-border);
}

.RedoSearch-redoContent-zGvws label {
  margin-bottom: 0;
}

.RedoSearch-redoText-PcuU5 {
  font-weight: 500;
  margin: 0px 0px 0px 10px;
  word-wrap: break-word;
  letter-spacing: 0.2px;
  padding-top: 0px;
  padding-bottom: 0px;
  color: var(--common-text-color);
}`, "",{"version":3,"sources":["webpack://./src/components/SearchListing/RedoSearch/RedoSearch.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,UAAU;EACV,QAAQ;EACR,8BAAsB;EAAtB,2BAAsB;EAAtB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,kBAAkB;EAClB,0CAAkC;UAAlC,kCAAkC;EAClC,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;AACjC","sourcesContent":[".redoContainer {\n  position: absolute;\n  bottom: 9px;\n  left: 0;\n  z-index: 1;\n  right: 0;\n  max-width: max-content;\n  margin: 0 auto;\n}\n\n.redoContent {\n  padding: 9px 15px;\n  background-color: var(--primary-white-bg);\n  border-radius: 6px;\n  box-shadow: 0px 8px 11px #3131310f;\n  display: flex;\n  align-items: flex-start;\n  border: 1px solid var(--primary-border);\n}\n\n.redoContent label {\n  margin-bottom: 0;\n}\n\n.redoText {\n  font-weight: 500;\n  margin: 0px 0px 0px 10px;\n  word-wrap: break-word;\n  letter-spacing: 0.2px;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  color: var(--common-text-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"redoContainer": `RedoSearch-redoContainer-K35GI`,
	"redoContent": `RedoSearch-redoContent-zGvws`,
	"redoText": `RedoSearch-redoText-PcuU5`
};
module.exports = ___CSS_LOADER_EXPORT___;
